// Translation imports
// Updated with buildingInnovation focus area cards and vidavo buildingFuture section
import { en } from './en';
import { el } from './el';
import { fr } from './fr';
import { de } from './de';
import { ar } from './ar';

export type Language = 'en' | 'el' | 'fr' | 'de' | 'ar';

export interface Translations {
  nav: {
    services: string;
    innovation: string;
    about: string;
    getInTouch: string;
    openMenu: string;
    closeMenu: string;
  };
  connectedCareHero: {
    healthForAll: string;
    anytime: string;
    anywhere: string;
    fullHeadline: string;
    subtitle: string;
    exploreServices: string;
    discoverVida24: string;
    keywords: {
      secondOpinion: string;
      telemedicine: string;
      smartNutrition: string;
      selfManagement: string;
      digitalTherapeutics: string;
      eWellness: string;
      behaviorChange: string;
      mentalHealth: string;
    };
  };
  hero: {
    badge: string;
    title: string;
    subtitle: string;
  };
  trustedBy: {
    title: string;
    subtitle: string;
    description: string;
    learnMore: string;
    faqTitle: string;
    faqSubtitle: string;
    faqs: {
      question1: string;
      answer1: string;
      question2: string;
      answer2: string;
      question3: string;
      answer3: string;
      question4: string;
      answer4: string;
      question5: string;
      answer5: string;
      question6: string;
      answer6: string;
    };
  };
  rdMenu: {
    researchOnDemand: string;
    rdPortfolio: string;
    buildingInnovation: string;
    digitalTransformation: string;
  };
  digitalTransformation: {
    badge: string;
    title: string;
    subtitle: string;
    projectTitle: string;
    projectTitleContent: string;
    briefDescription: string;
    briefDescriptionContent: string;
    investmentPlanBudget: string;
    investmentPlanBudgetContent: string;
    investmentPlanDisclaimer: string;
    investmentPlanEuFunding: string;
    investmentPlanEuFundingContent: string;
    logoAlt: string;
  };
  buildingInnovation: {
    badge: string;
    title: string;
    subtitle: string;
    focusAreasTitle: string;
    focusAreasSubtitle: string;
    focusAreas: string[];
    partnerTitle: string;
    partnerSubtitle: string;
    partners: {
      academic: {
        title: string;
        description: string;
      };
      healthcare: {
        title: string;
        description: string;
      };
      industry: {
        title: string;
        description: string;
      };
    };
  };
  researchOnDemand: {
    badge: string;
    title: string;
    subtitle: string;
    description: string;
    whatWeOffer: string;
    services: Array<{
      title: string;
      description: string;
    }>;
    globalNetwork: {
      badge: string;
      title: string;
      description: string;
    };
    trackRecord: {
      title: string;
      description: string;
    };
    stats: Array<{
      label: string;
    }>;
  };
  euNationalProjects: {
    badge: string;
    title: string;
    subtitle: string;
    projectDescriptions: {
      marissa: string;
      raise: string;
      valueCare: string;
      intelliot: string;
      inspect: string;
      pat: string;
      intelTriage: string;
      liver3d: string;
      sefac: string;
      cyberCare: string;
      im: string;
      smartcare: string;
      evolve2care: string;
      cyberSuite: string;
      cerebris: string;
      default: string;
    };
    seeMore: string;
    tapToFlip: string;
  };
  aboutMenu: {
    vidavoEU: string;
    vidavoIndia: string;
    vidavoThroughTime: string;
    whyUs: string;
    investorRelations: string;
    careers: string;
    vida24HomeCare: string;
  };
  vidavoMiddleEast: {
    pageTitle: string;
    metaDescription: string;
    badge: string;
    aiBadge: string;
    heroTitle: string;
    heroSubtitle: string;
    heroLead: string;
    heroText: string;
    heroImageAlt: string;
    platformTitle: string;
    platformText: string;
    platformCta: string;
    applicationImageAlt: string;
    aiTitle: string;
    aiText1: string;
    aiText2: string;
    futureTitle: string;
    futureText: string;
    ctaTitle: string;
    ctaText: string;
    ctaButton: string;
    readInArabic: string;
    tapToZoom: string;
  };
  vidavoIndia: {
    pageTitle: string;
    metaDescription: string;
    badge: string;
    heroTitle: string;
    heroText: string;
    heroImageAlt: string;
    whoWeAreTitle: string;
    whoWeAreText: string;
    platformLabel: string;
    platformTitle: string;
    platformText: string;
    demoButton: string;
    solutionsTitle: string;
    solutions: { title: string; description: string }[];
    innovationTitle: string;
    innovationText: string;
    experienceTitle: string;
    experienceText: string;
    discoverTitle: string;
    discoverText: string;
    contactButton: string;
    ctaEmail: string;
  };
  vidavoEU: {
    badge: string;
    title: string;
    titlePart1: string;
    titleHighlight: string;
    subtitle: string;
    ctaButton: string;
    section1Title: string;
    section1Intro: string;
    section1Cards: {
      card1Title: string;
      card1Desc: string;
      card2Title: string;
      card2Desc: string;
      card3Title: string;
      card3Desc: string;
    };
    section2Title: string;
    section2Subtitle: string;
    section2AddressLabel: string;
    section2Address: string;
    section2EmailLabel: string;
    section2Email: string;
    section2Footer: string;
    vida24Title: string;
    vida24Intro: string;
    vida24Benefits: string[];
    vida24Closing: string;
    euroCollabTitle: string;
    euroCollabDescription: string;
    euroCollabNote: string;
    getInTouchTitle: string;
    getInTouchDescription: string;
    getInTouchSubtext: string;
    getInTouchCTA: string;
  };
  vidavo: {
    badge: string;
    title: string;
    subtitle: string;
    timeline: {
      event2025: string;
      event2024: string;
      event2023: string;
      event2021: string;
      event2020: string;
      event2019: string;
      event2015: string;
      event2014: string;
      event2011: string;
      event2010: string;
      event2007: string;
      event2005: string;
      event2002: string;
    };
    buildingFuture: {
      title: string;
      description: string;
    };
  };
  whyUs: {
    badge: string;
    title: string;
    subtitle: string;
    advantages: Array<{
      title: string;
      description: string;
    }>;
    unGlobalCompact: {
      title: string;
      description: string;
      pillars: {
        humanRights: string;
        labour: string;
        environment: string;
        antiCorruption: string;
      };
    };
  finalStatement: {
    title: string;
    description: string;
  };
};

investorRelations: {
  title: string;
  description: string;
  stockExchange: {
    title: string;
    ticker: string;
    description: string;
    issuersCorner: string;
    stockInfo: string;
  };
  keyMetrics: {
    revenueGrowth: {
      label: string;
      value: string;
      description: string;
    };
    marketPenetration: {
      label: string;
      value: string;
      description: string;
    };
    healthcarePartners: {
      label: string;
      value: string;
      description: string;
    };
    patientLives: {
      label: string;
      value: string;
      description: string;
    };
  };
  documents: {
    title: string;
    download: string;
    categories: {
      financial: string;
      governance: string;
      presentations: string;
      regulatory: string;
      assemblies: string;
    };
    names: {
      annualReport: string;
      firstSemester: string;
      balanceSheet: string;
      balanceSheetFirstSemester: string;
      announcement: string;
      generalMeeting: string;
      corporatePresentation: string;
    };
  };
  contact: {
    title: string;
    description: string;
    sendEmail: string;
  };
};

careers: {
  title: string;
  subtitle: string;
  whyWorkAtVidavo: {
    title: string;
    description: string;
    culture: {
      title: string;
      description: string;
      values: {
        innovation: string;
        learning: string;
        collaboration: string;
        impact: string;
      };
    };
  };
  noOpenPositions: {
    description: string;
    linkedIn: string;
    descriptionEnd: string;
    sendEmail: string;
  };
};
  personalData: {
    badge: string;
    title: string;
    description: string;
    sections: {
      usefulDefinitions: string;
      dataController: string;
      whatDataWeProcess: string;
      informationRegardingCookies: string;
      yourRights: string;
      periodOfStorage: string;
      informationSecurityPolicy: string;
      purposesAndLegalBasis: string;
      thirdPartyLinks: string;
      revisions: string;
      antiBriberyPolicy: string;
    };
    usefulDefinitionsContent: {
      intro: string;
      personalData: string;
      sensitiveData: string;
      dataProcessing: string;
      legislation: string;
      dataLogs: string;
      cookies: string;
      specificInformation: string;
      cookiesEnd: string;
    };
    dataControllerContent: {
      paragraph1: string;
      paragraph2: string;
    };
    whatDataWeProcessContent: {
      sectionA: string;
      dataLogs: string;
      dataLogsIntro: string;
      dataLogsList: string[];
      cookiesSubtitle: string;
      cookiesText: string;
      sectionB: string;
      sectionBText: string;
    };
    cookiesInfoContent: {
      intro: string;
      essentialTitle: string;
      essentialText: string;
      analyticsTitle: string;
      analyticsText: string;
      tableHeaders: {
        cookieName: string;
        category: string;
        purpose: string;
        duration: string;
      };
      tableData: Array<{
        name: string;
        category: string;
        purpose: string;
        duration: string;
      }>;
      managingTitle: string;
      managingText: string;
    };
    yourRightsContent: {
      intro: string;
      rights: string[];
      contactTitle: string;
      contactText1: string;
      contactText2: string;
    };
    purposesAndLegalBasisContent: {
      paragraph1: string;
      paragraph2: string;
    };
    thirdPartyLinksContent: string;
    revisionsContent: string;
    periodOfStorageContent: {
      ipAddress: string;
      sessionCookies: string;
      emailData: string;
      claimsData: string;
    };
    informationSecurityPolicyContent: {
      intro: string;
      coversTitle: string;
      coversList: string[];
      objectivesTitle: string;
      objectivesList: string[];
      additionalInfo?: string;
      managingDirector: string;
      name: string;
    date: string;
    };
    antiBriberyPolicyContent: {
      policySummary: {
        title: string;
        intro: string;
        conjunction: string;
      };
      purposeAndObjectives: {
        title: string;
        content: string;
      };
      risksAndConsequences: {
        title: string;
        content: string;
      };
      scopeAndRange: {
        title: string;
        content: string;
      };
      policyDetails: {
        title: string;
        applicableLaws: {
          title: string;
          content: string;
        };
        prohibitionOfBribery: {
          title: string;
          governmentBribery: {
            title: string;
            content: string;
          };
          commercialBribery: {
            title: string;
            content: string;
          };
          facilitationPayments: {
            title: string;
            content: string;
          };
        };
        provisionOfItems: {
          title: string;
          governmentTransactionApproval: {
            title: string;
            content: string;
          };
          giftsMealsTravel: {
            title: string;
            content: string;
          };
          gifts: {
            title: string;
            content: string;
          };
          promotionDemonstration: {
            title: string;
            content: string;
          };
          hiringGovernmentOfficials: {
            title: string;
            content: string;
          };
          politicalContributions: {
            title: string;
            content: string;
          };
        };
        thirdPartyManagement: {
          title: string;
          applicability: {
            title: string;
            paragraph1: string;
            paragraph2: string;
          };
          dueDiligence: {
            title: string;
            paragraph1: string;
            paragraph2: string;
            paragraph3: string;
            paragraph4: string;
          };
        };
        education: {
          title: string;
          paragraph1: string;
          paragraph2: string;
        };
        audit: {
          title: string;
          content: string;
        };
        reportingViolations: {
          title: string;
          content: string;
        };
      };
      managingDirector: string;
      name: string;
    };
  };
  cookies: {
    banner: {
      title: string;
      description: string;
      acceptAll: string;
      necessaryOnly: string;
      settings: string;
    };
    dialog: {
      title: string;
      description: string;
      necessary: {
        label: string;
        description: string;
      };
      analytics: {
        label: string;
        description: string;
      };
      cancel: string;
      savePreferences: string;
    };
  };
  scrollCarousel: {
    steps: {
      step1: { title: string; description: string };
      step2: { title: string; description: string };
      step3: { title: string; description: string };
      step4: { title: string; description: string };
      step5: { title: string; description: string };
      step6: { title: string; description: string };
      step7: { title: string; description: string };
      step8: { title: string; description: string };
    };
  };
  collaboratorsCarousel: {
    title: string;
    subtitle: string;
    products: {
      vida24: string;
      vida24Healthcare: string;
      vida24Monitoring: string;
      vidAware: string;
      vidATrack: string;
      vida24Marine: string;
      vida: string;
      vida24Vet: string;
    };
  };
  processFlow: {
    steps: {
      step1: { title: string; description: string };
      step2: { title: string; description: string };
      step3: { title: string; description: string };
      step4: { title: string; description: string };
      step5: { title: string; description: string };
      step6: { title: string; description: string };
      step7: { title: string; description: string };
    };
  };
  footer: {
    partnerText: string;
    becomePartner: string;
    ourOffices: string;
    thessalonikiHQ: string;
    thessalonikiAddress: string;
    thessalonikiAddress2: string;
    athens: string;
    athensAddress: string;
    ioannina: string;
    ioanninaAddress: string;
    vidavoEU: string;
    vidavoEUAddress: string;
    callUsAt: string;
    emailUsAt: string;
    followUs: string;
    copyright: string;
    allRightsReserved: string;
    personalData: string;
    cookieNotice: string;
    backToTop: string;
    aboutVidavo: string;
  };
  services: {
    hero: {
      title: string;
      subtitle: string;
    };
    categories: {
      telemedicine: {
        title: string;
        description: string;
        services: Array<{
          title: string;
          description: string;
        }>;
      };
      wellness: {
        title: string;
        description: string;
        services: Array<{
          title: string;
          description: string;
        }>;
      };
      smartHealth: {
        title: string;
        description: string;
        services: Array<{
          title: string;
          description: string;
        }>;
      };
      advisory: {
        title: string;
        description: string;
        services: Array<{
          title: string;
          description: string;
        }>;
      };
    };
    servicesAvailable: string;
    cta: {
      title: string;
      description: string;
      scheduleConsultation: string;
    };
  };
  chronicConditionManagement: {
    title: string;
    subtitle: string;
    ourApproach: {
      title: string;
      description: string;
    };
    keyFeatures: {
      title: string;
      features: string[];
    };
    conditionsWeSupport: {
      title: string;
      description: string;
    };
  };
  serviceModal: {
    title: string;
    description: string;
    altTexts: {
      mobileHealthApp: string;
      insurtechDashboard: string;
      ecoHealthDashboard: string;
      digitalAnimalHealth: string;
      aiDecisionSupport: string;
      digitalHealthConsulting: string;
      scientificWellness: string;
      ehealthWellnessTourism: string;
    };
    specificDescriptions: {
      insurtech: string;
      ecoHealth: string;
      aiDecisionSupport: string;
      digitalHealthConsulting: string;
      scientificWellness: string;
      ehealthWellnessTourism: string;
    };
  };
  serviceData: {
    chronicDiseaseTelemedicine: {
      description: string;
      features: Array<{ title: string; description: string }>;
    };
    digitalOutpatientClinic: {
      description: string;
      features: Array<{ title: string; description: string }>;
    };
    emergencyPanicButton: {
      description: string;
      features: Array<{ title: string; description: string }>;
    };
    mentalHealthSupport: {
      description: string;
      features: Array<{ title: string; description: string }>;
    };
    pregnancyMonitoring: {
      description: string;
      features: Array<{ title: string; description: string }>;
    };
    marineTelemedicine: {
      description: string;
      features: Array<{ title: string; description: string }>;
    };
    behaviouralChangeSolutions: {
      description: string;
      features: Array<{ title: string; description: string }>;
    };
    corporateWellbeing: {
      description: string;
      features: Array<{ title: string; description: string }>;
    };
    scientificWellness: {
      description: string;
      features: Array<{ title: string; description: string }>;
    };
    ehealthWellnessTourism: {
      description: string;
      features: Array<{ title: string; description: string }>;
    };
    insurtech: {
      description: string;
      features: Array<{ title: string; description: string }>;
    };
    digitalTherapeuticsPharma: {
      description: string;
      features: Array<{ title: string; description: string }>;
    };
    digitalAnimalHealth: {
      description: string;
      features: Array<{ title: string; description: string }>;
    };
    ecoHealthAnalytics: {
      description: string;
      features: Array<{ title: string; description: string }>;
    };
    aiDecisionSupport: {
      description: string;
      features: Array<{ title: string; description: string }>;
    };
    drgDecisionSupport: {
      description: string;
      features: Array<{ title: string; description: string }>;
    };
    digitalHealthConsulting: {
      description: string;
      features: Array<{ title: string; description: string }>;
    };
  };
  common: {
    learnMore: string;
  };
  vida24HomeCare: {
    meta: { title: string; description: string; ogTitle: string; ogDescription: string };
    hero: { titlePrefix: string; titleItems: string[]; subtitle: string; requestDemo: string };
    benefits: Array<{ title: string; text: string }>;
    howItWorks: { title: string; steps: Array<{ title: string; text: string }> };
    devices: { title: string; subtitle: string; items: Array<{ name: string; detail: string }> };
    capabilities: { title: string; items: Array<{ title: string; text: string }> };
    audiences: {
      title: string;
      subtitle: string;
      prev: string;
      next: string;
      slide: string;
      items: Array<{ title: string; items: string[] }>;
    };
    reasons: { title: string; items: Array<{ title: string; text: string }> };
    cta: { title: string; subtitle: string; demo: string; pilot: string; contact: string };
    contactModal: {
      titles: { demo: string; general: string; pilot: string };
      subtitle: string;
      labels: {
        firstName: string;
        lastName: string;
        organization: string;
        jobTitle: string;
        country: string;
        email: string;
        phone: string;
        message: string;
      };
      close: string;
      submit: string;
    };
  };
}

export const translations: Record<Language, Translations> = {
  en,
  el,
  fr,
  de,
  ar,
};

export const languageNames: Record<Language, string> = {
  en: 'English',
  el: 'Ελληνικά',
  fr: 'Français',
  de: 'Deutsch',
  ar: 'العربية',
};
